var PlatformVersionService = /** @class */ (function () {
    function PlatformVersionService(api) {
        this.API = api;
    }
    PlatformVersionService.prototype.fetchPlatformVersions = function () {
        return this.API.get('/platformversions');
    };
    PlatformVersionService.prototype.createPlatformVersion = function (upgradeType, changes, silent) {
        return this.API.post('/platformversions', {
            upgradeType: upgradeType,
            changes: changes,
            silent: silent,
        });
    };
    return PlatformVersionService;
}());
export { PlatformVersionService };
